export default {
    cart: [],
    method: 'boleto',
    cardBrand: ''
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/components/store/state.js